import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../services/api";
import CompletedLoads from "./CompletedLoads";
import LoadsInProgress from "./LoadsInProgress";
import DeleteButton from "./DeleteButton";

function ProductDetails() {
  const { id } = useParams();
  const [product, setProduct] = useState({});
  const [prevision, setPrevision] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate();

  const handleDeleteProduct = async (id) => {
    try {
      await api.delete(`/products/${id}`);
      navigate("/produtos");
    } catch (error) {
      console.error("erro ao excluir produto: ", error);
      setErrorMessage(
        "Erro ao excluir produto. Verifique se existe algum pedido com o mesmo."
      );
      return true;
    }
  };

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setIsLoading(true);
        const response = await api.get(`/products/product/id/${id}`);
        setProduct(response.data);
        setPrevision(response.data.prevision);

        console.log("json.string: ", JSON.stringify(response.data));
      } catch (error) {
        console.error("erro ao obter produto: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProduct();
  }, [id]);

  if (isLoading) return <h1>Carregando...</h1>;

  return (
    <div>
      <div className="w-[80%] flex justify-center mt-10 mx-auto">
        <div>
          <div className="flex justify-between">
            <p className="font-semibold text-lg">{product.name}</p>{" "}
            <div className="flex gap-4">
              <button
                onClick={() => navigate(`/produtos/editar/${id}`)}
                className="bg-orange-500 px-3 py-2 rounded-md text-white hover:bg-orange-600"
              >
                Alterar produto
              </button>
              <DeleteButton
                onConfirm={() => handleDeleteProduct(id)}
                errorMessage={errorMessage}
                setErrorMessage={setErrorMessage}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 bg-gray-100 gap-x-10 mt-2 py-4 px-16 rounded-md">
            <div className="capitalize">
              <p className="font-bold text-md mr-10">Características gerais</p>
              <div className="mt-4 border-r-2 border-gray-400 flex flex-col gap-6 text-sm pr-2 font-semibold">
                <p>
                  NCM: <span className="font-normal">{product.ncm}</span>
                </p>
                <p>
                  Dimensões:{" "}
                  <span className="font-normal">{product.dimensions}</span>
                </p>
                <p>
                  Fardo com{" "}
                  <span className="font-normal">
                    {product.quantity} unidades
                  </span>
                </p>
              </div>
            </div>
            <div className="capitalize">
              <p className="font-bold text-md">Impostos</p>
              <div className="mt-4  flex flex-col gap-1 text-sm pr-2 font-semibold">
                <p>
                  II:{" "}
                  <span className="ml-2 font-normal">{product.ii * 100}%</span>{" "}
                </p>
                <p>
                  IPI:{" "}
                  <span className="ml-2 font-normal">{product.ipi * 100}%</span>
                </p>
                <p>
                  ICMS:{" "}
                  <span className="ml-2 font-normal">
                    {product.icms * 100}%
                  </span>
                </p>
                <p>
                  PIS/PASEP:{" "}
                  <span className="ml-2 font-normal">{product.pis * 100}%</span>{" "}
                </p>
                <p>
                  COFINS:{" "}
                  <span className="ml-2 font-normal">
                    {product.cofins * 100}%
                  </span>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* loads */}
      <div className="w-[90%] flex justify-between mt-10 mx-auto gap-10">
        <CompletedLoads orderItems={product.Order_Items} />
        <LoadsInProgress orderItems={product.Order_Items} />
      </div>
    </div>
  );
}
export default ProductDetails;
